import { UserStatusEnum } from '@acme/api/client';
import { Alert } from 'flowbite-react';

export interface AccountStatusAlertProps {
  status?: UserStatusEnum;
  date?: string;
}

const formatDate = (dateString?: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

const formatDateTime = (dateString?: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const dateStr = formatDate(dateString);
  const timeStr = date.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${dateStr}, ${timeStr}`;
};

const checkIcon = (
  <svg
    className="w-4 h-4"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

export const AccountStatusAlert = ({
  status,
  date: currentStatusStartAt,
}: AccountStatusAlertProps) => {
  if (status === UserStatusEnum.Confirmed) {
    return (
      <Alert
        color="success"
        className="bg-green-50 rounded-[6px] px-4 py-2 border-0"
      >
        <span className="text-sm font-normal text-green-800">
          Учетная запись активирована:{' '}
          {currentStatusStartAt ? formatDateTime(currentStatusStartAt) : ''}
        </span>
      </Alert>
    );
  }

  if (status === UserStatusEnum.ExpectsChanges) {
    return (
      <Alert
        color="failure"
        className="bg-red-50 rounded-[6px] px-4 py-2 border-0"
      >
        <div className="flex flex-col gap-1.5">
          <div className="flex gap-2 items-center">
            {checkIcon}
            <span className="text-base font-semibold text-red-800">
              Профиль не активирован
            </span>
          </div>
          <p className="text-sm font-normal text-red-800">
            Нужно поменять данные
          </p>
        </div>
      </Alert>
    );
  }

  if (status === UserStatusEnum.Blocked) {
    return (
      <Alert
        color="failure"
        className="bg-red-50 rounded-[6px] px-4 py-2 border-0"
      >
        <div className="flex flex-col gap-1.5">
          <div className="flex gap-2 items-center">
            {checkIcon}
            <span className="text-base font-semibold text-red-800">
              Профиль не активирован
            </span>
          </div>
          <p className="text-sm font-normal text-red-800">
            Нужно поменять данные в поле «ОГРН», «Корр. счёт», «СНИЛС»
          </p>
        </div>
      </Alert>
    );
  }

  if (status === UserStatusEnum.AwaitingСonfirmation) {
    return (
      <Alert
        color="warning"
        className="bg-orange-50 rounded-[6px] px-4 py-2 border-0"
      >
        <div className="flex flex-col gap-1.5">
          <div className="flex gap-2 items-center">
            {checkIcon}
            <span className="text-base font-semibold text-orange-800">
              Данные на проверке
            </span>
          </div>
          <p className="text-sm font-normal text-orange-800">
            {currentStatusStartAt
              ? `Данные отправлены на проверку ${formatDate(
                  currentStatusStartAt
                )}`
              : 'Данные отправлены на проверку. Ожидайте подтверждения.'}
          </p>
        </div>
      </Alert>
    );
  }

  return null;
};
